import { Fade } from "react-awesome-reveal";
import abc from "assets/images/brands/abc.png";
import tlc from "assets/images/brands/tlc.png";
import ktla5 from "assets/images/brands/ktla5.png";
import ocbs from "assets/images/brands/ocbs.png";
import fox from "assets/images/brands/fox.png";

const Brands = () => {
  return (
    <div className="brands_wrapper">
      {/* <Fade triggerOnce delay={700} duration={1600}> */}
        <h3>MamaZen has been featured on:</h3>
      {/* </Fade> */}
      <div className="brands_row d_flex align_items_center justify_content_center">
        <img src={abc} alt="" />
        <img src={tlc} alt="" />
        <img src={ktla5} alt="" />
        <img src={ocbs} alt="" />
        <img src={fox} alt="" />
      </div>
    </div>
  );
};

export default Brands;
